DomainesAvecTypesSelectController.$inject = ['$scope', 'DomainesService', 'MassiaApplicationService', '_'];

export default function DomainesAvecTypesSelectController($scope, DomainesService, MassiaApplicationService, _) {
	/* jshint validthis: true */
	const vm = this;
	vm.$scope = $scope;

	// Propriétés
	vm.loading = false;
	vm.domaines = [];

	// Méthodes
	vm.selectDomaine = selectDomaine;
	vm.refreshDomaines = refreshDomaines;
	vm.filterDomaines = filterDomaines;

	// Evènements
	vm.$onInit = onInit;

	// Méthodes publiques
	function onInit() {
		// vm.personnalise = vm.personnalise || false;
		vm.refreshDomaines();
		vm.excludes = vm.excludes || [];
		vm.clearOnSelect = vm.clearOnSelect || false;
		vm.selected = vm.selected || null;
		vm.disabled = vm.disabled || false;
		//watcher sur personnalise => appel à refreshDomaines
		vm.$scope.$watch(
			() => vm.personnalise,
			() => {
				vm.refreshDomaines();
			}
		);
	}

	function selectDomaine(item) {
		vm.onSelect ? vm.onSelect({ domaine: item }) : (vm.selected = item);

		if (vm.clearOnSelect) {
			vm.selected = undefined;
		}
	}

	async function refreshDomaines() {
		let data;
		try {
			data = await DomainesService.getDomaines(MassiaApplicationService.getApplication(), true);
			if (vm.personnalise === true && data) {
				data = data.filter((x) => x.code == 'Produits');
			}
		} catch (ex) {
			data = [];
		}
		vm.domaines = data;
		if (vm.personnalise === true && (!vm.excludes || vm.excludes.length == 0)) {
			vm.selectDomaine(data[0]);
		}
		if (vm.selected && vm.selected.idDomaine) {
			vm.selected = _.find(vm.domaines, { idDomaine: vm.selected.idDomaine });
		}
	}

	function filterDomaines(item) {
		return !_.find(vm.excludes, { idDomaine: item.idDomaine });
	}
}
